module.exports = __webpack_public_path__ + "img/camera.43eec54e.jpg";